import randomBackground from "../randomBackground";

export function ensureHiddenCanvas() {
  let existing = document.getElementById(
    "displayCanvas"
  ) as HTMLCanvasElement | null;
  if (!existing) {
    const c = document.createElement("canvas");
    c.id = "displayCanvas";
    c.width = window.innerWidth;
    c.height = window.innerHeight;
    c.style.position = "fixed";
    c.style.left = "-9999px";
    c.style.top = "-9999px";
    c.style.display = "none";
    document.body.appendChild(c);
    existing = c;
  }
  return existing;
}

export const setRandomBackground = async () => {
  ensureHiddenCanvas();

  const background = randomBackground();

  const body = document.getElementsByClassName("body")?.[0];

  if (body) {
    body.setAttribute(
      "style",
      `background: black url('${background}') no-repeat fixed top`
    );
  }
};
